module.exports = __webpack_public_path__ + "static/img/xfxb2.5d9157a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/xfxb2.jpg
// module id = 7vez
// module chunks = 0